import React, { useState, useEffect, useCallback } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import {
  Box,
  Typography,
  Paper,
  Pagination,
  Button,
  Tooltip,
  Grid,
  Tabs,
  Tab,
} from "@mui/material";
import SearchFilter from "../../Requirement/components/common/SearchFilter";
import DataTable from "../../Requirement/components/common/ReusableTable";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
// Assuming RemarksThread is imported from the appropriate path
import RemarksThread from "./component/RemarksThread";
import { useLoading } from "../../../context/LoadingContext";
import {
  fetchData,
  postQuery,
  uploadFileToS3Path,
  searchfetchQueries,
} from "../../../services/BackendServices";
import config from "../../../aws-exports";
import AlertModal from "../../Requirement/components/common/AlerModel";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const SectionHeader = ({ children }) => (
  <Box sx={{ mb: 3, pb: 2, borderBottom: "1px solid #e2e8f0" }}>
    <Typography variant="h6" sx={{ fontWeight: 600, color: "#1e293b" }}>
      {children}
    </Typography>
  </Box>
);

const BuyerKYB = (mode = "Buyer") => {
  const navigate = useNavigate();
  const [kybData, setKybData] = useState([]);
  const [kyGlobalbData, setKyGlobalbData] = useState([]);

  const bucket = process.env.REACT_APP_AMTPL_BUCKET;
  let bucketfolder = "public/media/amtpl/kybdoc";
  const filePath = `${bucketfolder}/`;
  const fileUrl = `https://${bucket}.s3.${config.aws_project_region}.amazonaws.com/${filePath}`;

  const [searchValues, setSearchValues] = useState({
    legalName: "",
    status: "",
    type: "",
    country: "",
  });
  const [rowStart, setRowStart] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [updatedStatus, setUpdatedStatus] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const { setLoading, loading } = useLoading();
  const [error, setError] = useState(null);
  const [activeUser, setActiveUser] = useState("");
  const [activeUserName, setActiveUserName] = useState("");
  const [activeMode, setActiveMode] = useState("");

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const statusOptions = ["Pending", "Approved"];
  const typeOptions = ["Buyer", "Global Partner"];

  // Fetch KYB data from API
  const fetchKybData = useCallback(async (newRowStart = rowStart) => {
    setLoading(true);
    setError(null);
    console.log("searchValues@@", searchValues);
    try {
      if(activeMode!==mode.mode){
        setRowStart(0);
        newRowStart=0;
      }
      const userKybs = await fetchData({
        target: "listUserKYBAdmin",
        userOrder: "CreatedAt DESC",
        rowStart: newRowStart,
        pageSize: pageSize,
        filterTerms: {
          UserType: mode.mode,
          LegalBusinessNamePartial: searchValues.legalName || "",
          Status: searchValues.status || "",
        },
      });

      // Assuming userKybs is { items: [...], total: ... }
      const fetchedData = userKybs.items || [];
      // setTotalItems(userKybs.total || fetchedData.length);
      setTotalItems(userKybs.total || 0);

      // Separate data based on entityType
      // const buyerData = fetchedData.filter((item) => item.UserType === "Buyer");
      // const globalData = fetchedData.filter(
      //   (item) => item.UserType === "GlobalPartner"
      // );

      // setKybData(buyerData);
      // setKyGlobalbData(globalData);
      // setFilteredData(mode.mode === "Buyer" ? buyerData : globalData);
      setFilteredData(fetchedData);
      setActiveMode(mode.mode);
    } catch (err) {
      console.error("Error fetching KYB data:", err);
      setError("Failed to fetch KYB data. Please try again.");
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  }, [rowStart, pageSize, mode, searchValues]);

  const fields = [
    {
      name: "legalName",
      label: "Legal Name",
      type: "text",
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, legalName: value })),
      value: searchValues.legalName,
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      options: statusOptions.map((status) => ({
        value: status,
        label: status,
      })),
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, status: value })),
      value: searchValues.status,
    },
    // {
    //     name: "type",
    //     label: "Entities",
    //     type: "dropdown",
    //     options: typeOptions.map((type) => ({ value: type, label: type })),
    //     onChange: (value) => setSearchValues((prev) => ({ ...prev, type: value })),
    //     value: searchValues.type,
    // }
  ];

  const handleSearch = useCallback(
    (searchValues) => {
      setRowStart(0);
      fetchKybData();
    },
    [searchValues]
  );

  // const handlePageChange = (event, newPage) => {
  //   const newRowStart = (newPage - 1) * pageSize;
  //   setRowStart(newRowStart);
  // };
  const handlePageChange = useCallback(
      (page) => {
        const newRowStart = (page - 1) * pageSize;
        setRowStart(newRowStart);
        // setIsOfferDetailVisible(false);
      },
      [pageSize]
    );

  const handleReviewClick = async (row) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchData({
        target: "getUserKYB",
        UserKybID: row.UserKybID,
      });

      // Parse the nested JSON string in body.items
      let userKybSettings = response.items;

      // Map API response to the selectedRow format
      const detailedRow = {
        id: userKybSettings.UserKybID,
        legalBusinessName: userKybSettings.LegalBusinessName,
        tradingName: userKybSettings.TradingName,
        hasTradingName:
          userKybSettings.hasTradingName === 1 ||
          userKybSettings.hasTradingName === true,
        businessType: userKybSettings.BusinessType,
        industrySector: userKybSettings.IndustrySector,
        regNumber: userKybSettings.CompanyRegistrationNumber,
        dateOfIncorporation: userKybSettings.DateOfIncorporation,
        countryOfIncorporation: userKybSettings.CountryOfIncorporation,
        taxId: userKybSettings.TaxIdentificationNumber,
        registeredAddress: userKybSettings.RegisteredAddress,
        operationalAddress: userKybSettings.OperationalAddress,
        isOperationalDifferent:
          userKybSettings.isOperationalDifferent === 1 ||
          userKybSettings.isOperationalDifferent === true,
        website: userKybSettings.Website,
        contactNumber: userKybSettings.ContactNumber,
        annualTurnover: userKybSettings.AnnualTurnover,
        paidUpCapital: userKybSettings.PaidUpCapital,
        bankName: userKybSettings.BankName,
        bankAccountNumber: userKybSettings.BankAccountNumber,
        ifscSwift: userKybSettings.IFSC_SwiftCode,
        sourceOfFunds: userKybSettings.SourceOfFunds,
        status: userKybSettings.Status,
        remarks: userKybSettings.Remarks,
        dateOfApproval: userKybSettings.DateOfApproval,
        dateOfSubmission: userKybSettings.DateOfSubmission,
        createdAt: userKybSettings.CreatedAt,
        updatedAt: userKybSettings.UpdatedAt,
        emailId: userKybSettings.EmailID,
        amtUserId: userKybSettings.AMTPLUserID,
        gpEmailId: userKybSettings.GPEmailID,
        secondaryEmailId: userKybSettings.SecondaryEmailID,
        firstName: userKybSettings.FirstName,
        lastName: userKybSettings.LastName,
        userType: userKybSettings.UserType,
        certificateOfIncorporation: userKybSettings.certificateOfIncorporation,
        taxIdProof: userKybSettings.taxIdProof,
        lastAuditedFinancials: userKybSettings.lastAuditedFinancials,
        promoterName: userKybSettings.PromoterName,
        ownershipDisclosed: userKybSettings.OwnershipDisclosed,
        shareholding: userKybSettings.Shareholding,
        mgmtExperience: userKybSettings.MgmtExperience,
        directorNames: userKybSettings.DirectorNames,
        tradingYears: userKybSettings.TradingYears,
        tradeVolume: userKybSettings.TradeVolume,
        eximExperience: userKybSettings.EximExperience,
        commodities: userKybSettings.Commodities,
        countriesTraded: userKybSettings.CountriesTraded,
        amlPolicy: userKybSettings.AmlPolicy,
        kycSubmitted: userKybSettings.KycSubmitted,
        sanctionsCheck: userKybSettings.SanctionsCheck,
        litigation: userKybSettings.Litigation,
        websiteUrl: userKybSettings.WebsiteUrl,
        // emailDomain: userKybSettings.lastAuditedFinancials,
        websiteAge: userKybSettings.WebsiteAge,
        // phoneNumber: userKybSettings.lastAuditedFinancials,
        accountType: userKybSettings.AccountType,
        bankYears: userKybSettings.BankYears,
        lcUsage: userKybSettings.LcUsage,
        documents: [
          userKybSettings.certificateOfIncorporation
            ? {
                type: "Certificate of Incorporation",
                url: userKybSettings.certificateOfIncorporation,
              } // Assuming string is filename or URL path
            : null,
          userKybSettings.taxIdProof
            ? {
                type: "Tax Identification Proof",
                url: userKybSettings.taxIdProof,
              }
            : null,
          userKybSettings.lastAuditedFinancials
            ? {
                type: "Last Audited Financials",
                url: userKybSettings.lastAuditedFinancials,
              }
            : null,
        ].filter(Boolean), // Remove null entries
      };

      setSelectedRow(detailedRow);
      setUpdatedStatus(detailedRow.status);
    } catch (err) {
      console.error("Error fetching detailed KYB data:", err);
      setError("Failed to fetch detailed KYB data. Please try again.");
    } finally {
      setLoading(false);
    }
    setActiveTab(0);
  };

  const handleRowClick = (row) => {
    handleReviewClick(row);
  };

  const handleCloseReview = () => {
    setSelectedRow(null);
    setUpdatedStatus("");
    setActiveTab(0);
  };

  // Function to convert JSON to xlsx and trigger download
  const downloadCSV = async () => {
    setLoading(true);
    try {
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      let dataToExport = [];
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listUserKYBAdmin",
          userOrder: "UserKybID",
          rowStart: 0,
          pageSize: 1,
          filterTerms: { UserType: mode.mode },
        }),
      ]);

      const totalCount = initialResponse?.total || initialResponse?.length || 0;

      if (totalCount > 0) {
        const [allKybData] = await Promise.all([
          searchfetchQueries({
            target: "listUserKYBAdmin",
            userOrder: "UserKybID",
            rowStart: 0,
            pageSize: totalCount,
            filterTerms: { UserType: mode.mode },
          }),
        ]);
        dataToExport = allKybData;
        console.log("allKybData@@", allKybData);
      }

      let fileName = `${mode.mode}_KYB_Data_${dayjs().format("YYYYMMDD")}`;
      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (error) {
      console.error("Error loading data: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStatus = async () => {
    if (!selectedRow || updatedStatus === selectedRow.status) {
      // No change or no row selected
      return;
    }

    setLoading(true);
    setError(null);
    try {
      // Prepare the update input based on the selectedRow mapping (reverse of fetch)
      // Only updating Status and DateOfApproval if Approved; assuming Remarks handled separately
      const currentDate = dayjs().format("YYYY-MM-DD");
      const userKYBInput = {
        UserKybID: selectedRow.id,
        EmailID: selectedRow.emailId,
        ContactNumber: selectedRow.contactNumber,
        LegalBusinessName: selectedRow.legalBusinessName,
        TradingName: selectedRow.tradingName,
        BusinessType: selectedRow.businessType,
        IndustrySector: selectedRow.industrySector,
        CompanyRegistrationNumber: selectedRow.regNumber,
        DateOfIncorporation: selectedRow.dateOfIncorporation
          ? dayjs(selectedRow.dateOfIncorporation).format("YYYY-MM-DD")
          : currentDate,
        RegisteredAddress: selectedRow.registeredAddress,
        OperationalAddress: selectedRow.operationalAddress,
        CountryOfIncorporation: selectedRow.countryOfIncorporation,
        TaxIdentificationNumber: selectedRow.taxId,
        Website: selectedRow.website,
        AnnualTurnover: parseFloat(selectedRow.annualTurnover) || 0,
        PaidUpCapital: parseFloat(selectedRow.paidUpCapital) || 0,
        BankName: selectedRow.bankName,
        BankAccountNumber: selectedRow.bankAccountNumber,
        IFSC_SwiftCode: selectedRow.ifscSwift,
        SourceOfFunds: selectedRow.sourceOfFunds,
        Status: updatedStatus,
        Remarks: "",
        DateOfApproval:
          updatedStatus === "Approved"
            ? currentDate
            : selectedRow.dateOfApproval || currentDate,
        DateOfSubmission: selectedRow.dateOfSubmission
          ? dayjs(selectedRow.dateOfSubmission).format("YYYY-MM-DD")
          : currentDate,
        hasTradingName: selectedRow.hasTradingName ? 1 : 0,
        isOperationalDifferent: selectedRow.isOperationalDifferent ? 1 : 0,
        certificateOfIncorporation:
          selectedRow.certificateOfIncorporation || "",
        taxIdProof: selectedRow.taxIdProof || "",
        lastAuditedFinancials: selectedRow.lastAuditedFinancials || "",
      };

      await postQuery({
        target: "updateUserKYB",
        userKYBInput,
      });

      // Update local state optimistically
      selectedRow.status = updatedStatus;
      selectedRow.dateOfApproval = userKYBInput.DateOfApproval;

      fetchKybData();

      setModal({
        show: true,
        type: "success",
        title: "Success!",
        message: "KYB status updated successfully.",
        autoClose: false,
      });
    } catch (err) {
      console.error("Error updating KYB status:", err);
      setError("Failed to update status. Please try again.");
      setModal({
        show: true,
        type: "error",
        title: "Error!",
        message: error.message || "Failed to update status. Please try again.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    let bgColor = "",
      textColor = "";
    switch (status) {
      case "Pending":
        bgColor = "#fef3c7";
        textColor = "#b45309";
        break;
      case "Approved":
        bgColor = "#d1fae5";
        textColor = "#065f46";
        break;
      case "Verified":
        bgColor = "#d1fae5";
        textColor = "#065f46";
        break;
      default:
        bgColor = "#f3f4f6";
        textColor = "#374151";
    }
    return (
      <Box
        sx={{
          backgroundColor: bgColor,
          color: textColor,
          padding: "4px 10px",
          borderRadius: "999px",
          fontSize: "0.75rem",
          fontWeight: 500,
          display: "inline-block",
        }}
      >
        {status === "Pending" ? "In Review" : status}
      </Box>
    );
  };

  // const paginatedData = filteredData.slice(rowStart, rowStart + pageSize);

  const columns = [
    { id: "LegalBusinessName", numeric: false, label: "Legal Name" },
    { id: "CountryOfIncorporation", numeric: false, label: "Country" },
    { id: "CompanyRegistrationNumber", numeric: false, label: "CIN/BRN" },
    { id: "EmailID", numeric: false, label: "Email ID" },
    {
      id: "CreatedAt",
      numeric: false,
      label: "Submitted",
      renderCell: (row) =>
        row.CreatedAt ? dayjs(row.CreatedAt).format("DD-MM-YYYY") : "",
    },
    {
      id: "Status",
      numeric: false,
      label: "Status",
      renderCell: (row) => getStatusBadge(row.Status),
    },
    // {
    //   id: "action",
    //   numeric: false,
    //   label: "Action",
    //   renderCell: (row) => (
    //     <Button
    //       variant="outlined"
    //       size="small"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         handleReviewClick(row);
    //       }}
    //       sx={{
    //         color: "#de6b14",
    //         textTransform: "none",
    //         borderColor: "#de6b14",
    //         "&:hover": {
    //           borderColor: "#de6b14",
    //           backgroundColor: "#de6b14",
    //           color: "white",
    //         },
    //       }}
    //     >
    //       Review
    //     </Button>
    //   ),
    // },
  ];

  // const pageCount = Math.ceil(totalItems / pageSize);
  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const renderDisplayField = (label, value) => (
    <div className="col-md-6">
      <label className="form-label" style={{ fontWeight: 500, color: "#666" }}>
        {label}
      </label>
      <div className="p-2 border rounded bg-light">
        <p className="mb-0">{value || "N/A"}</p>
      </div>
    </div>
  );
  const renderDisplayFieldFullWidth = (label, value) => (
    <div className="col-md-12">
      <label className="form-label" style={{ fontWeight: 500, color: "#666" }}>
        {label}
      </label>
      <div className="p-2 border rounded bg-light">
        <p className="mb-0">{value || "N/A"}</p>
      </div>
    </div>
  );

  const renderDocumentField = (label, doc) => (
    <div className="col-md-6">
      <label className="form-label" style={{ fontWeight: 500, color: "#666" }}>
        {label}
      </label>
      <div className="p-2 border rounded bg-light d-flex justify-content-between align-items-center">
        {doc ? (
          <>
            <p className="mb-0">{doc.type || "Unknown Document"}</p>
            <button
              className="btn btn-link ms-2 p-0"
              style={{ textDecoration: "none" }}
              onClick={() => {
                // Construct full URL if needed, e.g., `https://your-s3-bucket/${doc.url}`
                // For now, assuming doc.url is the path or full URL
                window.open(fileUrl + doc.url, "_blank"); // Or use your S3 viewer logic
              }}
            >
              View Document
            </button>
          </>
        ) : (
          <p className="mb-0 text-muted">N/A (No document uploaded)</p>
        )}
      </div>
    </div>
  );

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);

        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_ADMINS")) {
          await Auth.signOut();
          navigate("/");
        } else {
          const email = user.attributes.email;
          const usrname = user.attributes.given_name;
          setActiveUser(email);
          setActiveUserName(usrname);
        }
      } catch (error) {
        await Auth.signOut();
        navigate("/");
      }
    };

    checkUser();
  }, [navigate]);

  // Fetch data on component mount and when dependencies change
  useEffect(() => {
    fetchKybData();
  }, [fetchKybData, searchValues]);

  return (
    <div className="container">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <Paper elevation={2} sx={{ p: 3 }}>
        <div className="search-filter4">
          <div className="title4">
            <div className="head-text">{mode.mode} KYB</div>{" "}
            {/* Fixed: Single braces */}
          </div>
          <div className="filter4">
            <SearchFilter fields={fields} onSearch={handleSearch} />
          </div>
          <div className="download-csv">
            <button className="submit-btn-more" onClick={downloadCSV}>
              Download Data(XLSX)
            </button>
          </div>
        </div>

        <div className="table-content">
          <DataTable
            columns={columns}
            data={filteredData}
            total={totalItems}
            title="KYBs"
            onPageChange={handlePageChange}
            rowsPerPage={pageSize}
            currentPage={currentPage}
            selectedRows={selectedRow ? [selectedRow.id] : []}
            onRowClick={handleRowClick}
            initialOrderBy="CreatedAt"
          />
        </div>
        
      </Paper>

      {selectedRow && (
        <Paper elevation={2} sx={{ p: 4, mt: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <div className="review-text">
              <b>KYB Profile Review:</b> {selectedRow.legalBusinessName}
            </div>
            <div className="d-flex gap-2 align-items-center">
              <button className="submit-btn-more" onClick={handleUpdateStatus}>
                Submit
              </button>

              <button className="submit-btn-more" onClick={handleCloseReview}>
                Cancel
              </button>
            </div>
          </Box>
          <>
            <div className="container-fluid">
              <div className="row mb-3">
                <div className="col-12">
                  <div
                    className="d-flex justify-content-between align-items-center p-2"
                    style={{
                      backgroundColor:
                        selectedRow.status === "Approved"
                          ? "#d1fae573"
                          : "#fef3c750",
                      color:
                        selectedRow.status === "Approved"
                          ? "#065f46"
                          : "#b45309",
                      borderLeft:
                        selectedRow.status === "Approved"
                          ? "3px solid #00b658fb"
                          : "3px solid #b69203f7",
                      borderRadius: "5px",
                    }}
                  >
                    <span
                      className="p-1 px-2 rounded"
                      style={{ fontSize: "0.875rem" }}
                    >
                      Current Status: {getStatusBadge(selectedRow.status)}
                    </span>
                    <div className="d-flex gap-2">
                      {/* <button className="btn btn-outline-warning" style={{ textTransform: 'none' }}>
                                                Request Clarification
                                            </button> */}
                    </div>
                  </div>
                </div>
              </div>

              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                sx={{ mb: 2, "& .MuiTabs-indicator": { display: "none" } }}
              >
                <Tab
                  label="Legal Identity"
                  sx={{
                    borderBottom: "2px solid #de6b14 !important",
                    "&:not(.Mui-selected)": {
                      borderBottom: "none",
                      border: "none",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#de6b14 !important",
                      color: "white",
                      borderBottom: "2px solid #de6b14 !important",
                      border: "none",
                    },
                  }}
                />
                <Tab
                  label="Ownership"
                  sx={{
                    borderBottom: "2px solid #de6b14 !important",
                    "&:not(.Mui-selected)": {
                      borderBottom: "none",
                      border: "none",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#de6b14 !important",
                      color: "white",
                      borderBottom: "2px solid #de6b14 !important",
                      border: "none",
                    },
                  }}
                />
                <Tab
                  label="Trade History"
                  sx={{
                    borderBottom: "2px solid #de6b14 !important",
                    "&:not(.Mui-selected)": {
                      borderBottom: "none",
                      border: "none",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#de6b14 !important",
                      color: "white",
                      borderBottom: "2px solid #de6b14 !important",
                      border: "none",
                    },
                  }}
                />
                <Tab
                  label="Compliance"
                  sx={{
                    borderBottom: "2px solid #de6b14 !important",
                    "&:not(.Mui-selected)": {
                      borderBottom: "none",
                      border: "none",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#de6b14 !important",
                      color: "white",
                      borderBottom: "2px solid #de6b14 !important",
                      border: "none",
                    },
                  }}
                />
                <Tab
                  label="Operational"
                  sx={{
                    borderBottom: "2px solid #de6b14 !important",
                    "&:not(.Mui-selected)": {
                      borderBottom: "none",
                      border: "none",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#de6b14 !important",
                      color: "white",
                      borderBottom: "2px solid #de6b14 !important",
                      border: "none",
                    },
                  }}
                />
                <Tab
                  label="Banking"
                  sx={{
                    borderBottom: "2px solid #de6b14 !important",
                    "&:not(.Mui-selected)": {
                      borderBottom: "none",
                      border: "none",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#de6b14 !important",
                      color: "white",
                      borderBottom: "2px solid #de6b14 !important",
                      border: "none",
                    },
                  }}
                />
                <Tab
                  label="Remarks"
                  sx={{
                    borderBottom: "2px solid #de6b14 !important",
                    "&:not(.Mui-selected)": {
                      borderBottom: "none",
                      border: "none",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#de6b14 !important",
                      color: "white",
                      borderBottom: "2px solid #de6b14 !important",
                      border: "none",
                    },
                  }}
                />
              </Tabs>

              {/* Tab 0: Legal Identity */}
              {activeTab === 0 && (
               <Box className="tab-content">
                  <div className="card">
                    <SectionHeader variant="h6" gutterBottom>
                      Legal & Regulatory Identity
                    </SectionHeader>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      <div className="col-md-6">
                        <label
                          className="form-label"
                          style={{ fontWeight: 500, color: "#666" }}
                        >
                          Status
                        </label>
                        <select
                          value={updatedStatus}
                          onChange={(e) => setUpdatedStatus(e.target.value)}
                          className="form-select"
                        >
                          <option value="Pending">Pending</option>
                          <option value="Approved">Approved</option>
                          <option value="Rejected">Rejected</option>
                        </select>
                      </div>
                    </div>

                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "Legal Business Name",
                        selectedRow.legalBusinessName
                      )}
                      {renderDisplayField(
                        "Trading Name",
                        selectedRow.tradingName
                      )}
                    </div>

                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "Business Type",
                        selectedRow.businessType
                      )}
                      {renderDisplayField(
                        "Industry Sector",
                        selectedRow.industrySector
                      )}
                    </div>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "Registration Number (CIN / BRN)",
                        selectedRow.regNumber
                      )}
                      {renderDisplayField(
                        "Date of Incorporation",
                        selectedRow.dateOfIncorporation
                          ? dayjs(selectedRow.dateOfIncorporation).format(
                              "YYYY-MM-DD"
                            )
                          : "N/A"
                      )}
                    </div>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "Country of Incorporation",
                        selectedRow.countryOfIncorporation
                      )}
                      {renderDisplayField(
                        "Tax Identification Number (e.g., GSTIN / PAN / VAT)",
                        selectedRow.taxId
                      )}
                    </div>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDocumentField(
                        "Certificate of Incorporation Document",
                        selectedRow.documents[0]
                      )}
                      {renderDocumentField(
                        "Tax Identification Proof (EIN)",
                        selectedRow.documents[1]
                      )}
                    </div>
                    
                  </div>
                </Box>
              )}

              {/* Tab 1: Ownership */}
              {activeTab === 1 && (
                <Box className="tab-content">
                  <div className="card">
                  <SectionHeader variant="h6" gutterBottom>
                    Ownership & Management
                  </SectionHeader>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "Promoter / Founder Name",
                        selectedRow.promoterName
                      )}
                      {renderDisplayField(
                        "Ownership Disclosed?",
                        selectedRow.ownershipDisclosed
                      )}
                    </div>

                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "% Shareholding Known",
                        selectedRow.shareholding
                      )}
                      {renderDisplayField(
                        "Management Experience (Years)",
                        selectedRow.mgmtExperience
                      )}
                    </div>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayFieldFullWidth(
                        "Key Management Names",
                        selectedRow.directorNames
                      )}
                      
                    </div>
                    
                  </div>
                </Box>
              )}

              {/* Tab 2: Trade History */}
              {activeTab === 2 && (
                <Box className="tab-content">
                  <div className="card">
                  <SectionHeader variant="h6" gutterBottom>
                    Trade History & Operations
                  </SectionHeader>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "Years in Commodity Trading",
                        selectedRow.tradingYears
                      )}
                      {renderDisplayField(
                        "Annual Trade Volume Range",
                        selectedRow.tradeVolume
                      )}
                    </div>

                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "Export/Import Experience?",
                        selectedRow.eximExperience
                      )}
                      {renderDisplayFieldFullWidth(
                        "Main Commodities Traded (comma separated)",
                        selectedRow.commodities
                      )}
                      {renderDisplayFieldFullWidth(
                        "Countries Traded With  (comma separated)",
                        selectedRow.countriesTraded
                      )}
                    </div>
                    
                  </div>
                </Box>
              )}

              {/* Tab 3: Compliance */}
              {activeTab === 3 && (
                <Box className="tab-content">
                  <div className="card">
                  <SectionHeader variant="h6" gutterBottom>
                    Compliance Declarations
                  </SectionHeader>

                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "AML Policy Declared",
                        selectedRow.amlPolicy
                      )}
                      {renderDisplayField(
                        "KYC Documents Submitted",
                        selectedRow.kycSubmitted
                      )}
                      {renderDisplayField(
                        "Sanctions Compliance Declaration",
                        selectedRow.sanctionsCheck
                      )}
                      {renderDisplayField(
                        "Litigation Disclosure (Ongoing legal cases)",
                        selectedRow.litigation
                      )}
                    </div>

                  </div>
                </Box>
              )}

              {/* Tab 4: Operational */}
              {activeTab === 4 && (
                <Box className="tab-content">
                  <div className="card">
                  <SectionHeader variant="h6" gutterBottom>
                    Digital & Operational Presence
                  </SectionHeader>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      <div className="col-md-12">
                        <label
                          className="form-label"
                          style={{ fontWeight: 500, color: "#666" }}
                        >
                          Registered Address
                        </label>
                        <div className="p-2 border rounded bg-light">
                          <p className="mb-0">
                            {selectedRow.registeredAddress || "N/A"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      <div className="col-md-12">
                        <label
                          className="form-label"
                          style={{ fontWeight: 500, color: "#666" }}
                        >
                          {selectedRow.isOperationalDifferent
                            ? "Operational Address"
                            : "Operational Address (Same as Registered)"}
                        </label>
                        <div className="p-2 border rounded bg-light">
                          <p className="mb-0">
                            {selectedRow.isOperationalDifferent
                              ? selectedRow.operationalAddress
                              : "Same as Registered Address"}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "Company Website URL",
                        selectedRow.websiteUrl
                      )}
                      {renderDisplayField(
                        "Official Email Domain",
                        selectedRow.website
                      )}
                      {renderDisplayField(
                        "Years Website Active",
                        selectedRow.websiteAge
                      )}
                      {renderDisplayField(
                        "Business Phone Number",
                        selectedRow.contactNumber
                      )}
                    </div>
                  </div>
                </Box>
              )}

              {/* Tab 5: Banking */}
              {activeTab === 5 && (
                <Box className="tab-content">
                  <div className="card">
                  <SectionHeader variant="h6" gutterBottom>
                    Banking Relationship
                  </SectionHeader>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "Annual Turnover (Last Reported Year)",
                        selectedRow.annualTurnover
                      )}
                      {renderDisplayField(
                        "Paid-up Capital",
                        selectedRow.paidUpCapital
                      )}
                    </div>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "Primary Operating Bank Name",
                        selectedRow.bankName
                      )}
                      {renderDisplayField(
                        "Bank Account Number",
                        selectedRow.bankAccountNumber
                      )}
                    </div>
                    <div className="row" style={{ marginBottom: "10px" }}>
                      {renderDisplayField(
                        "IFSC / SWIFT Code",
                        selectedRow.ifscSwift
                      )}
                      {renderDisplayField(
                        "Primary Source of Funds",
                        selectedRow.sourceOfFunds
                      )}
                      {renderDisplayField(
                        "Account Type",
                        selectedRow.accountType
                      )}
                      {renderDisplayField(
                        "Years with Bank",
                        selectedRow.bankYears
                      )}
                      {renderDisplayField(
                        "LC / BG Usage History?",
                        selectedRow.lcUsage
                      )}
                    
                      {renderDocumentField(
                        "Last Audited Financials",
                        selectedRow.documents[2]
                      )}
                    </div>
                  </div>
                </Box>
              )}

              {/* Tab 6: Remarks */}
              {activeTab === 6 && (
                <Box className="tab-content">
                  <RemarksThread
                    kybId={selectedRow.id}
                    currentUserId={activeUser}
                    currentUserName={activeUserName}
                  />
                </Box>
              )}
            </div>
          </>
        </Paper>
      )}
    </div>
  );
};

export default BuyerKYB;
